/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
/* eslint-disable react/function-component-definition */
import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../commons/Auth';
import CompanyNavBar from '../../components/CompanyNavBar';
import HumanResourceDetail from '../../components/HumanResourceDetail';
import HumanResourceNoContent from '../../components/HumanResourceDetail/HumanResourceNoContent';
import unlockProfile from '../../lib/api/unlockProfile';
import useHumanResource from '../../lib/hooks/useHumanResource';
import useHumanResourceMutation from '../../lib/hooks/useHumanResourceMutation';

const ResourceProfile: React.FC = () => {
  const { token }: any = useAuth();
  const params = useParams();
  const { data: user, isLoading } = useHumanResource(params.id, token);
  const { mutate: mutateUnlockeds, isLoading: isLoadingUnlock } = useHumanResourceMutation(unlockProfile);

  return (
    <>
      <CompanyNavBar />
      <div className="bg-profilehead bg-no-repeat h-72 w-full bg-cover" />
      {isLoading || isLoadingUnlock || user ? (
        <HumanResourceDetail
          isLoading={isLoading || isLoadingUnlock}
          user={user}
          onUnlock={(data: any) => mutateUnlockeds({ ...data, token })}
        />
      ) : (
        <HumanResourceNoContent />
      )}
    </>
  );
};

export default ResourceProfile;